import React from 'react';
import {BrowserRouter as Router, Switch, Route, Redirect} from 'react-router-dom';
import {isMobile} from 'react-device-detect';
import {inject, observer} from 'mobx-react';
import {Loading} from '@enos/dpl';
import LandingPage from './LandingPage';
import Tutorial from './Tutorial';
import DocGlobalSearch from './DocGlobalSearch';
import LandingPageMobile from './LandingPageMobile';
import TutorialMobile from './TutorialMobile';
import NotFound from '../components/404';
import {getLanguageKey, getLatestVersion, getLandingConfig} from '../utils/tools';
import RequestStore from '../stores/request';
import '../assets/icons/portal/style.css';
import '~/assets/styles/index.less';

const latestVersion = getLatestVersion(Object.keys(getLandingConfig(getLanguageKey())).filter((v) => v !== 'preview'));
@inject('RequestStore')
@observer
class App extends React.Component {
 routes = (
   <Switch>
     <Route exact path='/:locale/globalSearch' component={DocGlobalSearch} />
     <Route exact path='/:locale/:version/tutorial' component={Tutorial} />
     <Route exact path='/:locale/:version' component={LandingPage} />
     <Route exact path='/:locale' render={({match: {params: {locale}}}) => <Redirect to={`/${locale}/${latestVersion}`} />} />
     <Route exact path='/' render={() => <Redirect to={`/${getLanguageKey()}/${latestVersion}`} />} />
     <Route component={NotFound} />
   </Switch>
  );

  routesMobile = (
    <Switch>
      <Route exact path='/:locale/:version/tutorial' component={TutorialMobile} />
      <Route exact path='/:locale/:version' component={LandingPageMobile} />
      <Route exact path='/:locale' render={({match: {params: {locale}}}) => <Redirect to={`/${locale}/${latestVersion}`} />} />
      <Route exact path='/' render={() => <Redirect to={`/${getLanguageKey()}/${latestVersion}`} />} />
      <Route component={NotFound} />
    </Switch>
  )

  componentDidMount() {
    if (process.env.AUTH) {
      RequestStore.getSession(); // Determine whether the user is logged in and intercept the request response
    } else {
      RequestStore.setLoading(false);
    }
  }

  render() {
    return (
      RequestStore.loading
        ? <Loading visible style={{height: '100%'}} />
        : (
          <Router basename='/docs'>
            {isMobile ? this.routesMobile : this.routes}
          </Router>
        )

    );
  }
}

export default App;
